export const sortByTimeAscending = (a: number[], b: number[]): number => {
  if (a[0] > b[0]) return 1;
  if (a[0] < b[0]) return -1;
  else return 0;
};
